module.exports = __webpack_public_path__ + "static/media/g5.7c75b5ca.jpg";